module.exports = "/static/9d0e7c384e3f43f0516f82b6de0ee494.png";